import { render, staticRenderFns } from "./_albumId.vue?vue&type=template&id=08a3c6b1&scoped=true&"
import script from "./_albumId.vue?vue&type=script&lang=ts&"
export * from "./_albumId.vue?vue&type=script&lang=ts&"
import style0 from "./_albumId.vue?vue&type=style&index=0&id=08a3c6b1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a3c6b1",
  null
  
)

export default component.exports